import security from './../images/security.png';

const Security = () => {
    return (
      <div>
      <p className="standard-paragraph">
      
      <div class="container">
        <div class="image-container">
          <img src={security} alt="Security" width={300}/>
        </div>
        <div class="text-container">
          <h2>Security</h2>
          <p class="text-text">  
            Fortify your AWS infrastructure with our comprehensive security services. We specialize in implementing robust security measures, 
            ensuring the confidentiality, integrity, and availability of your data on the cloud. As part of our overarching software development 
            services, we provide end-to-end support, guaranteeing a secure foundation for your applications through continuous monitoring, 
            threat detection, and adherence to industry-leading security practices.
          </p>
        </div>
      </div>


      <ul class="custom-list">
        <li><strong>AWS Identity and Access Management (IAM):</strong> Manage user and resource access, permissions, and authentication securely.</li>
        <li><strong>AWS Security Hub:</strong> Centrally manage security findings and compliance checks from multiple AWS services.</li>
        <li><strong>Amazon GuardDuty:</strong> Detect threats and vulnerabilities in real-time through intelligent threat detection.</li>
        <li><strong>Amazon Inspector:</strong> Assess the security and compliance of your applications and resources.</li>
        <li><strong>Amazon Macie:</strong> Automatically discover, classify, and protect sensitive data, such as personally identifiable information (PII).</li>
        <li><strong>AWS Key Management Service (KMS):</strong> Create and manage encryption keys to protect data at rest and in transit.</li>
        <li><strong>AWS Certificate Manager:</strong> Provision, manage, and deploy Secure Sockets Layer (SSL) and Transport Layer Security (TLS) certificates.</li>
        <li><strong>AWS WAF (Web Application Firewall):</strong> Protect web applications from common web exploits and attacks, including SQL injection and XSS.</li>
        <li><strong>AWS Firewall Manager:</strong> Centrally configure and manage AWS WAF rules across multiple resources.</li>
        <li><strong>AWS Network Firewall:</strong> Protect your virtual private cloud (VPC) with a managed network firewall service.</li>
        <li><strong>AWS Shield:</strong> Safeguard against Distributed Denial of Service (DDoS) attacks with various protection tiers.</li>
        <li><strong>Amazon VPC (Virtual Private Cloud):</strong> Isolate and secure resources in a logically isolated network environment.</li>
        <li><strong>AWS CloudTrail:</strong> Monitor and log AWS account activity to maintain a comprehensive audit trail.</li>
        <li><strong>Amazon Cognito:</strong> Manage user identities and authentication for your applications securely.</li>
        <li><strong>AWS Secrets Manager:</strong> Securely store, manage, and retrieve sensitive information such as passwords and API keys.</li>
        <li><strong>AWS Organizations:</strong> Centrally manage multiple AWS accounts to enforce security and compliance policies.</li>
        <li><strong>AWS Config:</strong> Continuously assess, audit, and evaluate configurations to ensure compliance with security best practices.</li>
        <li><strong>AWS Control Tower:</strong> Establish a secure, compliant, and multi-account AWS environment through a predefined setup.</li>
        <li><strong>AWS PrivateLink:</strong> Access AWS services securely over your private network without using the public internet.</li>
        <li><strong>AWS Encryption SDK:</strong> Simplify data encryption in applications with a client-side encryption library.</li>
        <li><strong>Amazon Detective:</strong> Investigate security issues with intelligent, automated analysis and visualization of log data.</li>
        <li><strong>AWS Artifact:</strong> Access security and compliance reports and artifacts to help meet regulatory requirements.</li>
      </ul>
      </p>
      </div>
      )
  };
  
  export default Security;